import type { PlanId } from "@/types/payment";

export const plans = {
  silver: {
    id: 'silver' as PlanId,
    name: 'Silver',
    prices: {
      month: '$9.99',
      year: '$99.99'
    },
    features: [
      "Basic features",
      "Email support",
      "1 project",
      "5GB storage"
    ]
  },
  gold: {
    id: 'gold' as PlanId,
    name: 'Gold',
    prices: {
      month: '$19.99',
      year: '$199.99'
    },
    features: [
      "All Silver features",
      "Priority support",
      "5 projects",
      "25GB storage",
      "Advanced analytics"
    ]
  },
  platinum: {
    id: 'platinum' as PlanId,
    name: 'Platinum',
    prices: {
      month: '$49.99',
      year: '$499.99'
    },
    features: [
      "All Gold features",
      "24/7 phone support",
      "Unlimited projects",
      "100GB storage",
      "Custom solutions",
      "Dedicated account manager"
    ]
  }
};